import { Socket, io } from "socket.io-client";
import { parse } from "cookie";
import type { DefaultEventsMap } from "@socket.io/component-emitter";
import parser from "socket.io-msgpack-parser";
import { SOCKET_LINK, socketOptions } from "src/config/constants";
import { authHeader } from "src/utils/authHeader";

export let socket: Socket<DefaultEventsMap, DefaultEventsMap>;

const connect = (onConnect: any) => {
  socket = io(`${SOCKET_LINK}/v1/userSubscribe`, {
    // forceNew: true,
    // withCredentials: true,
    // extraHeaders: {
    //     Authorization: authHeader(),
    // }
    parser,
    ...socketOptions,
    query: {
      authorization: authHeader(),
    },
  });

  const COOKIE_NAME = process.env.REACT_APP_SECRET_KEY || "betfair";

  socket.io.on("open", () => {
    console.info("🚀 ~ socket ~ open:");
    const transport: any = socket.io.engine.transport;
    transport.on("pollComplete", () => {
      const request = transport.pollXhr.xhr;
      const cookieHeader = request?.getResponseHeader("set-cookie");
      if (!cookieHeader) return;
      cookieHeader.forEach((cookieString: string) => {
        if (cookieString.includes(`${COOKIE_NAME}=`)) {
          const cookie = parse(cookieString);
          socket.io.opts.extraHeaders = {
            cookie: `${COOKIE_NAME}=${cookie[COOKIE_NAME]}`,
          };
        }
      });
    });
  });

  return new Promise((res, rej) => {
    socket?.on("connect", () => {
      console.info("🚀 ~ socket ~ connect:");
      onConnect(true);
      res(socket);
    });
    socket?.once("connect_error", (err) => {
      console.info("socket ~ connect_error:", err);
      rej(new Error("connect_error"));
    });
    socket?.once("connect_timeout", function (err) {
      console.info("socket ~ connect_timeout:", err);
      rej(new Error("connect_timeout"));
    });

    socket.io.on("reconnect_attempt", (attempt) => {
      console.info("🔁 socket ~ reconnect_attempt:", attempt);

      // refresh token each attempt (token may have changed)
      const token = authHeader();
      socket.io.opts.query = {
        ...(socket.io.opts.query as Record<string, any>),
        authorization: token,
      };
    });

    socket.io.on("reconnect", (attempt) => {
      console.info("✅ socket ~ reconnected after attempts:", attempt);
      onConnect(true);
    });

    socket.io.on("reconnect_error", (err) => {
      console.info("❌ socket ~ reconnect_error:", err);
    });

    socket.io.on("reconnect_failed", () => {
      console.info("🧨 socket ~ reconnect_failed (gave up)");
      onConnect(false);
    });

    socket?.on("disconnect", function (reason) {
      console.info("socket ~ disconnect:", reason);
      onConnect(false);
    });
  });
};

const reconnect = () => {
  if (!socket) return;
  if (socket.connected) return;

  console.log("🟦 manual reconnect() called");

  // refresh token before connecting
  socket.io.opts.query = {
    ...(socket.io.opts.query as Record<string, any>),
    authorization: authHeader(),
  };

  socket.connect();
};

const joinRoom = (data: any) => {
  socket?.emit("join-market-room", JSON.stringify(data));
};

const roomJoined = (setData: (arg0: any) => void) => {
  socket?.on("room-joined", (data) => {
    setData(data);
  });
};

const socketError = () => {
  socket?.on("error", (data) => {
    console.log("Socket Error", { data });
  });
};

const leaveRoom = (data: any) => {
  socket?.emit("market-leave", JSON.stringify(data));
};
const disconnect = (userIds: any) => {
  // socket?.disconnect()
  const data = {
    leave_userIds: userIds,
  };
  socket?.emit("leave-room", data);
};

const disconnect2 = () => {
  socket?.disconnect();
};

const refreshBookmakerList = (getMarkets: () => void) => {
  // console.log(`🚀 ~ EVENT_ADDED: refresh-bookmaker-list`);
  socket?.on("refresh-bookmaker-list", (data) => {
    // console.log(`🚀 ~ EVENT_DATA: refresh-bookmaker-list:`, data);
    getMarkets();
  });
};

const listenEvent = (eventName: any, setData: (arg0: any) => void) => {
  socket?.on(eventName, (data: any) => {
    setData(data);
  });
};

const refreshBetList = (getMarkets: () => void) => {
  socket?.on("refresh-bet-list", (data) => {
    if (data?.data?.is_bet_list) getMarkets();
  });
};

const chekUserConnected = (connectToRooms = () => {}) => {
  socket?.on("token-verified", (data) => {
    // console.log("IN users-connected - sport", data)
    if (data.data.isVerified) {
      connectToRooms();
    } else {
      // console.log('Its me')

      sessionStorage.clear();

      window.location.replace("/");
    }
  });
};

const socketServices = {
  connect,
  joinRoom,
  listenEvent,
  disconnect,
  disconnect2,
  leaveRoom,
  roomJoined,
  reconnect,
  socketError,
  refreshBetList,
  chekUserConnected,
  refreshBookmakerList,
};

export default socketServices;
